export const YasqeMode = {
    /**
     * The query can be edited.
     */
    WRITE: 'WRITE',

    /**
     * The editor is read-only, but the query can be copied.
     */
    READ: 'READ',

    /**
     * The editor is read-only and the query can't be copied.
     */
    PROTECTED: 'PROTECTED'
};
